import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { DownloadIcon } from '../atoms/Icons';
import useDownload from '../../hooks/useDownload';
var DownloadPreOrderRequestsCSVButton = function (_a) {
    var _b = _a.params, params = _b === void 0 ? {} : _b;
    var t = useTranslation().t;
    var preOrderRequestsDownload = useDownload({
        path: '/api/pre_order_requests.csv',
        downloadFilename: 'repeat_order_requests.csv',
        params: params,
    });
    return (React.createElement(IconButton, { onClick: preOrderRequestsDownload.handleDownload, disabled: preOrderRequestsDownload.downloading, "aria-label": "CSV Download", size: "large" },
        React.createElement(Tooltip, { title: t('buttons.downloadCsv') || '' },
            React.createElement(DownloadIcon, null))));
};
export default DownloadPreOrderRequestsCSVButton;
